/* PurrEase motion layer (Sep 27 2026).
   Additive only: it never changes prices, cart contents or the buy-box logic in purrease-calm-plan.js.
   Scroll reveals, parallax, count-ups, price ticks, gallery crossfade + swipe, FAQ easing.
   Skipped entirely when the visitor prefers reduced motion. */
(function () {
  'use strict';
  var root = document.getElementById('cp-top');
  if (!root) return;
  var html = document.documentElement;
  function mq(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }
  if (mq('(prefers-reduced-motion: reduce)')) return;
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
  html.classList.add('cpm-on');

  var FINE = mq('(hover: hover) and (pointer: fine)');
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[purrease-motion]', e); } }
  var vh = window.innerHeight;

  /* ---------- scroll container: Horizon scrolls .page-wrapper, not the window ---------- */
  var scroller = window;
  function findScroller() {
    var p = root.parentElement;
    while (p && p !== document.body && p !== html) {
      var s = getComputedStyle(p);
      if (/(auto|scroll)/.test(s.overflowY) && p.scrollHeight > p.clientHeight + 20) return p;
      p = p.parentElement;
    }
    return window;
  }
  function scrollPos() {
    if (scroller === window) {
      var d = document.scrollingElement || html;
      return { top: d.scrollTop || window.pageYOffset || 0, max: Math.max(1, d.scrollHeight - window.innerHeight) };
    }
    return { top: scroller.scrollTop, max: Math.max(1, scroller.scrollHeight - scroller.clientHeight) };
  }

  /* ---------- one rAF loop for everything scroll/pointer driven ---------- */
  var ticking = false;
  function requestTick() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
  document.addEventListener('scroll', requestTick, { capture: true, passive: true });
  window.addEventListener('resize', function () { vh = window.innerHeight; scroller = findScroller(); requestTick(); }, { passive: true });

  var bar = document.createElement('div');
  bar.className = 'cpm-bar';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  /* ---------- hero image: settle, cursor parallax, scroll zoom, crossfade, swipe ---------- */
  var media = $('.cp-media'), hero = $('#cp-hero-img');
  var H = { s: 1.04, ts: 1.04, x: 0, y: 0, tx: 0, ty: 0, live: false };
  function heroLive() {
    if (H.live || !hero) return;
    H.live = true;
    hero.style.animation = 'none';
    hero.style.transform = 'scale(1.04)';
    hero.style.willChange = 'transform';
    requestTick();
  }
  if (hero && media) {
    hero.addEventListener('animationend', heroLive);
    setTimeout(heroLive, 1800);
    if (FINE) {
      media.addEventListener('pointermove', function (e) {
        var r = media.getBoundingClientRect();
        H.tx = ((e.clientX - r.left) / r.width - 0.5) * -14;
        H.ty = ((e.clientY - r.top) / r.height - 0.5) * -14;
        H.ts = 1.07;
        requestTick();
      });
      media.addEventListener('pointerleave', function () { H.tx = 0; H.ty = 0; H.ts = 1.04; requestTick(); });
    }
  }

  var thumbs = $$('.cp-thumb');
  safe(function () {
    if (!hero || !media || !thumbs.length) return;
    thumbs.forEach(function (t) {
      // capture phase: runs before the page script swaps the src, so we can snapshot the old image
      t.addEventListener('click', function () {
        var next = t.getAttribute('data-src');
        if (!next || next === hero.getAttribute('src')) return;
        bump(t);
        var old = media.querySelector('.cpm-ov');
        if (old) old.parentNode.removeChild(old);
        var ov = document.createElement('img');
        ov.className = 'cpm-ov';
        ov.alt = '';
        ov.setAttribute('aria-hidden', 'true');
        ov.src = hero.currentSrc || hero.src;
        ov.style.transform = hero.style.transform;
        media.insertBefore(ov, hero.nextSibling);
        var faded = false;
        function fade() {
          if (faded) return;
          faded = true;
          H.s = 1.1;
          heroLive();
          requestTick();
          requestAnimationFrame(function () { ov.style.opacity = '0'; });
          setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 600);
        }
        hero.addEventListener('load', function once() { hero.removeEventListener('load', once); fade(); });
        setTimeout(fade, 900);
      }, true);
    });

    // swipe the hero on phones to move through the gallery
    var sx = 0, sy = 0, st = 0;
    media.addEventListener('touchstart', function (e) {
      var p = e.touches[0]; sx = p.clientX; sy = p.clientY; st = Date.now();
    }, { passive: true });
    media.addEventListener('touchend', function (e) {
      var p = e.changedTouches[0], dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4 || Date.now() - st > 700) return;
      var i = 0;
      thumbs.forEach(function (x, k) { if (x.classList.contains('cp-on')) i = k; });
      thumbs[(i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length].click();
    }, { passive: true });
  });

  /* ---------- band images: reveal zoom + parallax ---------- */
  var bands = $$('.cp-band-img').map(function (box) {
    var img = box.querySelector('img');
    return { box: box, img: img, vis: false, t0: 0 };
  }).filter(function (b) { return !!b.img; });
  var bandIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { var b = e.target.__cpmB; if (b) { b.vis = e.isIntersecting; if (b.vis) requestTick(); } });
  }, { rootMargin: '120px 0px' });
  bands.forEach(function (b) {
    b.box.__cpmB = b;
    b.img.style.willChange = 'transform';
    b.img.style.transform = 'scale(1.1)';
    bandIO.observe(b.box);
  });

  function tick() {
    ticking = false;
    var more = false;
    var sp = scrollPos();
    bar.style.transform = 'scaleX(' + clamp(sp.top / sp.max, 0, 1).toFixed(4) + ')';

    if (hero && media && H.live) {
      H.x += (H.tx - H.x) * 0.12;
      H.y += (H.ty - H.y) * 0.12;
      H.s += (H.ts - H.s) * 0.1;
      if (Math.abs(H.tx - H.x) > 0.05 || Math.abs(H.ty - H.y) > 0.05 || Math.abs(H.ts - H.s) > 0.0005) more = true;
      var r = media.getBoundingClientRect();
      var p = r.top < 0 ? clamp(-r.top / Math.max(1, r.height), 0, 1) : 0;
      var s = H.s + p * 0.06;
      var sy = p * (s - 1) / 2 * r.height * 0.8;
      var tf = 'translate3d(' + H.x.toFixed(2) + 'px,' + (H.y + sy).toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
      hero.style.transform = tf;
      var ov = media.querySelector('.cpm-ov');
      if (ov) ov.style.transform = tf;
    }

    bands.forEach(function (b) {
      if (!b.vis && !b.t0) return;
      var r = b.box.getBoundingClientRect();
      var c = clamp((r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2), -1, 1);
      var sc = 1.1;
      if (b.t0) {
        var k = clamp((now() - b.t0) / 1300, 0, 1);
        sc = 1.22 - 0.12 * (1 - Math.pow(1 - k, 3));
        if (k < 1) more = true; else b.t0 = 0;
      }
      var ty = -c * (sc - 1) / 2 * r.height * 0.85;
      b.img.style.transform = 'translate3d(0,' + ty.toFixed(2) + 'px,0) scale(' + sc.toFixed(4) + ')';
    });

    // anything already scrolled past gets revealed, so a fast fling or an anchor jump never leaves a blank section
    for (var gi = 0; gi < groups.length; gi++) {
      if (!groups[gi].done && groups[gi].c.getBoundingClientRect().top < vh * 0.94) reveal(groups[gi]);
    }
    for (var fi = fades.length - 1; fi >= 0; fi--) {
      var fe = fades[fi];
      if (fe.classList.contains('cp-in')) { fades.splice(fi, 1); continue; }
      if (fe.getBoundingClientRect().top < vh * 0.94) { fe.classList.add('cp-in'); fades.splice(fi, 1); }
    }

    if (more) requestTick();
  }

  /* ---------- staggered scroll reveals ---------- */
  function mark(el, o) {
    el.classList.add('cpm-r');
    if (o.x) el.style.setProperty('--cpm-x', o.x);
    if (o.y != null) el.style.setProperty('--cpm-y', o.y);
    if (o.s) el.style.setProperty('--cpm-s', o.s);
  }
  function unmark(el) {
    el.classList.remove('cpm-r', 'cpm-in', 'cpm-pi');
    ['--cpm-x', '--cpm-y', '--cpm-s', '--cpm-d'].forEach(function (v) { el.style.removeProperty(v); });
  }
  function show(el, d, cls) {
    el.style.setProperty('--cpm-d', d + 'ms');
    if (cls) el.classList.add(cls);
    function go() { el.classList.add('cpm-in'); }
    requestAnimationFrame(function () { requestAnimationFrame(go); });
    setTimeout(go, 80); // never leave content hidden if frames are throttled
    setTimeout(function () { unmark(el); }, d + 1000);
  }
  function countUp(b, delay) {
    if (!b) return;
    var txt = b.textContent, m = txt.match(/(\d+(?:\.\d+)?)/);
    if (!m) return;
    var target = parseFloat(m[1]), dec = (m[1].split('.')[1] || '').length;
    var pre = txt.slice(0, m.index), post = txt.slice(m.index + m[1].length);
    b.textContent = pre + (0).toFixed(dec) + post;
    setTimeout(function () { b.textContent = txt; }, delay + 1500); // guaranteed final value
    setTimeout(function () {
      var t0 = now();
      (function f() {
        var k = clamp((now() - t0) / 1100, 0, 1), e = 1 - Math.pow(1 - k, 3);
        b.textContent = k < 1 ? pre + (target * e).toFixed(dec) + post : txt;
        if (k < 1) requestAnimationFrame(f);
      })();
    }, delay);
  }

  var groups = [], fades = $$('.cp-fade');
  function group(container, items, o) {
    if (!container || !items || !items.length) return;
    // anything already on screen at load stays put: no flash, no re-animation
    if (container.getBoundingClientRect().top < vh * 0.92) return;
    items.forEach(function (it) { mark(it, o); });
    if (o.line) container.classList.add('cpm-line');
    groups.push({ c: container, items: items, o: o });
  }
  function run(g) {
    var base = g.o.base || 0, step = g.o.step || 80;
    if (g.o.line) g.c.classList.add('cpm-in');
    g.items.forEach(function (it, i) {
      var d = base + i * step;
      show(it, d);
      if (g.o.band && it.classList.contains('cp-band-img') && it.__cpmB) { it.__cpmB.t0 = now() + d; requestTick(); }
      if (g.o.pops) {
        $$('span', it).forEach(function (sp) {
          var t = sp.textContent.trim();
          if (t === '✓' || t === '✕') { sp.classList.add('cpm-pi'); show(sp, d + 200); }
        });
      }
      if (g.o.lis) $$('li', it).forEach(function (li, j) { mark(li, { x: '-10px', y: '0px' }); show(li, d + 220 + j * 70); });
      if (g.o.count) countUp(it.querySelector('b'), d + 120);
    });
  }

  safe(function () {
    group($('.cp-trust-grid'), $$('.cp-trust-item'), { y: '12px', step: 70 });
    $$('.cp-tl').forEach(function (tl) { group(tl, $$('.cp-tl-card', tl), { y: '26px', step: 130, line: true }); });
    var proof = $('.cp-proof');
    if (proof) group(proof, Array.prototype.slice.call(proof.children), { y: '16px', step: 90, count: true });
    $$('.cp-vs').forEach(function (v) { group(v, $$('.cp-vs-row', v), { x: '-14px', y: '0px', step: 55, pops: true }); });
    var og = $('#cp-once-grid');
    if (og) group(og, $$('.cp-oc', og), { y: '22px', step: 100 });
    var two = $('.cp-two');
    if (two) group(two, $$('.cp-card', two), { y: '24px', step: 140, lis: true });
    $$('.cp-band').forEach(function (b) {
      var items = [];
      var box = $('.cp-band-img', b); if (box) items.push(box);
      var chip = $('.cp-band-chip', b);
      $$('.cp-step', b).forEach(function (s) { items.push(s); });
      group(b, items, { x: b.classList.contains('cp-band-rev') ? '-18px' : '18px', y: '14px', step: 110, band: true });
      if (chip && box && box.classList.contains('cpm-r')) { mark(chip, { x: '-12px', y: '0px' }); chip.__cpmChip = true; }
    });
    var faq = $('.cp-faq');
    if (faq) group(faq, $$('details', faq), { y: '12px', step: 60 });
  });

  function reveal(g) {
    if (g.done) return;
    g.done = true;
    revealIO.unobserve(g.c);
    run(g);
    var chip = g.c.querySelector('.cp-band-chip');
    if (chip && chip.__cpmChip) show(chip, 650);
  }
  var revealIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && e.target.__cpmG) reveal(e.target.__cpmG); });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  groups.forEach(function (g) { g.c.__cpmG = g; revealIO.observe(g.c); });

  /* ---------- live feedback on the buy box ---------- */
  var ready = false;
  setTimeout(function () { ready = true; html.classList.add('cpm-ready'); }, 1700);
  function bump(el) {
    if (!el) return;
    el.classList.remove('cpm-bump');
    void el.offsetWidth;
    el.classList.add('cpm-bump');
    setTimeout(function () { el.classList.remove('cpm-bump'); }, 500);
  }
  safe(function () {
    $$('input[name="cprooms"]').forEach(function (inp) {
      inp.addEventListener('change', function () { bump(inp.nextElementSibling); });
    });
    $$('.cp-mode-btn').forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) bump(b); }); });
  });

  function tickEl(el) {
    el.classList.remove('cpm-tick');
    void el.offsetWidth;
    el.classList.add('cpm-tick');
  }
  // prices only get a visual tick; the page script's text is never overwritten
  function watchPrice(id) {
    var el = document.getElementById(id);
    if (!el || !window.MutationObserver) return;
    var last = el.textContent;
    new MutationObserver(function () {
      var t = el.textContent;
      if (t === last) return;
      last = t;
      if (ready) tickEl(el);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }
  safe(function () {
    ['cp-intro', 'cp-recurring', 'cp-st-total', 'cp-sticky-now', 'cp-final-price'].forEach(watchPrice);
    var h1 = document.getElementById('cp-h1');
    if (h1 && window.MutationObserver) {
      new MutationObserver(function () {
        if (!ready) return;
        var sp = h1.querySelector('span');
        if (sp) sp.classList.add('cpm-pop');
      }).observe(h1, { childList: true });
    }
  });

  /* ---------- FAQ: ease open and closed instead of snapping ---------- */
  safe(function () {
    $$('.cp-faq details').forEach(function (d) {
      var sm = d.querySelector('summary');
      if (!sm || !d.animate) return;
      sm.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !d.open || d.__cpmClosing;
        var from = d.getBoundingClientRect().height, to;
        if (d.__cpmA) { d.__cpmA.cancel(); d.__cpmA = null; }
        d.style.overflow = 'hidden';
        if (opening) {
          d.__cpmClosing = false;
          d.open = true;
          to = d.getBoundingClientRect().height;
        } else {
          d.__cpmClosing = true;
          to = sm.getBoundingClientRect().height + (d.offsetHeight - d.clientHeight);
        }
        var a = d.animate({ height: [from + 'px', to + 'px'] }, { duration: 340, easing: 'cubic-bezier(.2,.8,.2,1)' });
        d.__cpmA = a;
        a.onfinish = function () {
          d.__cpmA = null;
          d.style.overflow = '';
          if (!opening) d.open = false;
          d.__cpmClosing = false;
        };
      });
    });
  });

  /* ---------- soft spotlight that follows the cursor on cards (desktop only) ---------- */
  if (FINE) safe(function () {
    $$('.cp-tl-card, .cp-oc, .cp-room-card, .cp-two .cp-card:not(.cp-card-purple)').forEach(function (c) {
      c.classList.add('cpm-spot');
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--mx', Math.round(e.clientX - r.left) + 'px');
        c.style.setProperty('--my', Math.round(e.clientY - r.top) + 'px');
      });
      c.addEventListener('pointerleave', function () { c.style.removeProperty('--mx'); c.style.removeProperty('--my'); });
    });
  });

  scroller = findScroller();
  requestTick();
})();